import { render, staticRenderFns } from "./TftIntro.vue?vue&type=template&id=f2e5759c&"
import script from "./TftIntro.vue?vue&type=script&lang=js&"
export * from "./TftIntro.vue?vue&type=script&lang=js&"
import style0 from "./TftIntro.vue?vue&type=style&index=0&id=f2e5759c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports